import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { Injector } from '@angular/core';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Transaction } from '@models/transaction';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionsService } from '@services/entity/transactions.service';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-details-transaction',
  templateUrl: './details-transaction.component.html',
  styleUrls: ['./details-transaction.component.scss']
})
export class DetailsTransactionComponent extends AbstractEditEntityComponent implements OnInit {
  
  public className = 'DetailsTransactionComponent';

  public entity: TransactionDto;

  constructor(
    private transactionsService: TransactionsService,
    public injector: Injector) {
      super(transactionsService, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  initializeEntity(entity) {
    this.entity = plainToClass(TransactionDto, entity);
  }

  createForm() {
    //console.warn('Method not implemented.');
  }

  onSubmit(formValue: any) {
    //console.warn('Method not implemented.');
  }

}
